import { API_BASE_URL } from './apiUtils';
import { ApiResource } from './ApiResource';

export interface ValidateDiscountInput {
    discountCode: string;
    originalPrice: number;
}

export interface Discount {
    discountCode: string;
    codeIsValid: boolean;
    discountedPrice: number;
}

export async function validateDiscount(data: ValidateDiscountInput): Promise<ApiResource<Discount>> {
    try {
        const response = await fetch(`${API_BASE_URL}/api/ValidateDiscountCode`, {
            headers: { 'Content-Type': 'application/json' },
            method: 'POST',
            body: JSON.stringify(data),
        });
        if (!response.ok) {
            return { status: 'error' };
        }
        return {
            status: 'ok',
            data: (await response.json()) as Discount,
        };
    } catch (error) {
        return { status: 'error' };
    }
}
